import loglevel from 'loglevel';

loglevel.setDefaultLevel('INFO');

// TODO change all console.log to use logger

const logger = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  debug: (...msg: any[]) => loglevel.debug(msg),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  info: (...msg: any[]) => loglevel.info(...msg),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  warn: (...msg: any[]) => loglevel.warn(msg),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: (...msg: any[]) => loglevel.error(msg),
};

export { logger };
